/*
 *             Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
import _0x385080 from'./../../message.js';class GetAllSuggestionsMessage extends _0x385080{constructor(_0x1460b2){super(),this['documentId']=_0x1460b2;}['toJSON'](){return{'documentId':this['documentId']};}static['fromJSON'](_0x50392d){return new GetAllSuggestionsMessage(_0x50392d['documentId']);}}GetAllSuggestionsMessage['TYPE']='102',GetAllSuggestionsMessage['READABLE_TYPE_NAME']='getAllSuggestions',GetAllSuggestionsMessage['DESCRIPTOR_NAME']='TrackChangesGetAllSuggestionMessage',GetAllSuggestionsMessage['DESCRIPTOR']={'fields':{'documentId':{'type':'string','id':0x1}}};export default GetAllSuggestionsMessage;